import { FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin, FaEnvelope } from "react-icons/fa";

export default function ShareButtons({ title, url }) {
  const shareUrl = url || window.location.href;
  const shareTitle = title || "Britosa Mudanzas Madrid";
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(shareTitle);

  const buttons = [
    {
      icon: <FaWhatsapp />,
      label: "WhatsApp",
      href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      color: "#25D366"
    },
    {
      icon: <FaFacebook />,
      label: "Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      color: "#1877F2"
    },
    {
      icon: <FaTwitter />,
      label: "Twitter",
      href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      color: "#1DA1F2"
    },
    {
      icon: <FaLinkedin />,
      label: "LinkedIn",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      color: "#0A66C2"
    },
    {
      icon: <FaEnvelope />,
      label: "Email",
      href: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
      color: "#EA4335"
    }
  ];

  return (
    <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", alignItems: "center", margin: "1.5rem 0" }}>
      <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#0F4C75" }}>Compartir:</span>
      {buttons.map((btn) => (
        <a
          key={btn.label}
          href={btn.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Compartir en ${btn.label}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            background: btn.color,
            color: "#fff",
            fontSize: "1rem",
            textDecoration: "none",
            transition: "transform 0.2s ease",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
          onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
        >
          {btn.icon}
        </a>
      ))}
    </div>
  );
}
